import React, { useState } from 'react';
import { Center, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { TableCell, TableRow } from '../../shared/Table';
import { CollapsibleIcon } from '../../Icons/CollapsibleIcon';
import { TierDetails, ServiceOption } from '../types';
import { ServiceAvailabilityIndicator } from '../ServiceAvailabilityIndicator';
import { ServiceSubOptions } from './ServiceSubOptions';

interface SubscriptionTiersRowProps {
    serviceOption: ServiceOption;
    tierDetails: TierDetails[];
}

export const SubscriptionTiersRow = ({ serviceOption, tierDetails }: SubscriptionTiersRowProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const isCollapsible = serviceOption.subOptions.length > 0;

    const backgroundColor = isExpanded ? 'grey_200' : undefined;

    const handleExpand = () => {
        if (!isCollapsible) return;

        setIsExpanded((isPrevExpanded) => !isPrevExpanded);
    };

    return (
        <>
            <TableRow>
                <TableCell isSticky backgroundColor={backgroundColor}>
                    <Stack
                        paddingX="4"
                        paddingY="7"
                        alignItems="center"
                        onClick={handleExpand}
                        cursor={isCollapsible ? 'pointer' : 'default'}
                    >
                        <Text fontWeight="bold">{serviceOption.name}</Text>

                        {isCollapsible && (
                            <Center>
                                <CollapsibleIcon isCollapse={!isExpanded} />
                            </Center>
                        )}
                    </Stack>
                </TableCell>

                {tierDetails.map((tierDetail) => {
                    const detailsOption = tierDetail.options.find((option) => option.optionId === serviceOption.id);

                    if (!detailsOption) {
                        return <TableCell key={tierDetail.id} backgroundColor={backgroundColor} />;
                    }

                    return (
                        <TableCell key={tierDetail.id} backgroundColor={backgroundColor}>
                            <Center paddingX="4" paddingY="7">
                                <ServiceAvailabilityIndicator status={detailsOption.availabilityStatus} />
                            </Center>
                        </TableCell>
                    );
                })}
            </TableRow>

            {isExpanded && <ServiceSubOptions serviceOption={serviceOption} tierDetails={tierDetails} />}
        </>
    );
};
